import { videoModalActionTypes } from '@/components/modals/videoModal/Constants';

import type { ToggleVideoModalAction, VideoModalData } from './types';

export function toggleVideoModal(data: VideoModalData): ToggleVideoModalAction {
	return {
		type: videoModalActionTypes.TOGGLE_VIDEO_MODAL,
		payload: {
			data,
		},
	};
}
